export default function DriverPanel() {

  return (
      <p>پنل کاربری راننده</p>
  );
};